import api from "@/config/apiConfig"
import dateMessage from "@/utils/returnDateMessage";

class InternalChatController {

  async listConversations() {
    try {
      const response = await api.get("/internal-chat/conversations");
      response?.data?.forEach(item => {
        item.time = dateMessage(item.lastMessageAt || item.updatedAt || item.createdAt);
        // Pre-format contact text for compatible list rendering
        if (item.contact) {
            item.contact.text = item.contact.name;
        }
      });
      return response.data;
    } catch (error) {
      console.error("Erro no InternalChatController.listConversations: ", error);
      throw error;
    }
  }

  async getMessages(conversationId, params = {}) {
    try {
      const { page = 1, limit = 50 } = params;
      const response = await api.get(`/internal-chat/conversations/${conversationId}/messages`, {
        params: { page, limit }
      });
      return response.data;
    } catch (error) {
      console.error("Erro no InternalChatController.getMessages: ", error);
      throw error;
    }
  }

  async sendMessage(conversationId, body, medias = null) {
    try {
      const formData = new FormData();
      formData.append("conversationId", conversationId);
      formData.append("body", body || "");
      if (medias) {
        formData.append("medias", medias);
      }

      const response = await api.post("/internal-chat/messages", formData);
      return response.data;
    } catch (error) {
      console.error("Erro no InternalChatController.sendMessage: ", error);
      throw error;
    }
  }

  async listColleagues() {
    try {
      const response = await api.get("/internal-chat/colleagues");
      return response.data;
    } catch (error) {
      console.error("Erro no InternalChatController.listColleagues: ", error);
      throw error;
    }
  }

  async getOrCreatePrivate(targetUserId) {
    try {
      const response = await api.post("/internal-chat/conversations/private", { targetUserId });
      return response.data;
    } catch (error) {
      console.error("Erro no InternalChatController.getOrCreatePrivate: ", error);
      throw error;
    }
  }

  async createGroup(name, participantIds) {
    try {
      const response = await api.post("/internal-chat/conversations/group", { name, participantIds, type: 'group' });
      return response.data;
    } catch (error) {
      console.error("Erro no InternalChatController.createGroup: ", error);
      throw error;
    }
  }

  async getConversation(id) {
    try {
      const response = await api.get(`/internal-chat/conversations/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erro no InternalChatController.getConversation: ", error);
      throw error;
    }
  }

  async addParticipant(id, targetUserId) {
    try {
      const response = await api.post(`/internal-chat/conversations/${id}/participants`, { targetUserId });
      return response.data;
    } catch (error) {
      console.error("Erro no InternalChatController.addParticipant: ", error);
      throw error;
    }
  }

  async removeParticipant(id, userId) {
    try {
      const response = await api.delete(`/internal-chat/conversations/${id}/participants/${userId}`);
      return response.data;
    } catch (error) {
      console.error("Erro no InternalChatController.removeParticipant: ", error);
      throw error;
    }
  }

  async updateAdmin(id, userId, isAdmin) {
    try {
      const response = await api.patch(`/internal-chat/conversations/${id}/participants/${userId}/admin`, { isAdmin });
      return response.data;
    } catch (error) {
      console.error("Erro no InternalChatController.updateAdmin: ", error);
      throw error;
    }
  }

  async leaveGroup(id) {
    try {
      const response = await api.post(`/internal-chat/conversations/${id}/leave`);
      return response.data;
    } catch (error) {
      console.error("Erro no InternalChatController.leaveGroup: ", error);
      throw error;
    }
  }

  async deleteConversation(id) {
    try {
      const response = await api.delete(`/internal-chat/conversations/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erro no InternalChatController.deleteConversation: ", error);
      throw error;
    }
  }
}

export default new InternalChatController();
